import React from 'react';
import styled, { ThemeContext, ThemeProvider } from 'styled-components';
import { BentoTheme } from '../..';
import { ButtonComponent, ButtonProps, ButtonTheme, ButtonThemeDefinition } from '../Button/Button';

export const getButtonTheme = (bento: BentoTheme, theme: ButtonTheme): ButtonThemeDefinition => {
    const themeMap = {
        default: {
            bento,
            text: bento.colors.text.main,
            color: bento.colors.transparent,
            hover: {
                text: bento.colors.text.strong,
                color: bento.colors.neutral.weak,
            },
        },
        transparent: {
            bento,
            text: bento.colors.text.main,
            color: bento.colors.transparent,
            hover: {
                text: bento.colors.text.strong,
                color: bento.colors.neutral.pale || bento.colors.transparent,
            },
        },
        primary: {
            bento,
            text: bento.colors.primary.main,
            color: bento.colors.transparent,
            hover: {
                text: bento.colors.primary.strong,
                color: bento.colors.primary.strong,
            },
        },
        secondary: {
            bento,
            text: bento.colors.secondary.main,
            color: bento.colors.transparent,
            hover: {
                text: bento.colors.secondary.strong,
                color: bento.colors.secondary.strong,
            },
        },
        danger: {
            bento,
            text: bento.colors.danger.main,
            color: bento.colors.transparent,
            hover: {
                text: bento.colors.danger.strong,
                color: bento.colors.danger.strong,
            },
        },
    };

    return themeMap[theme];
};

const LinkButtonComponent = styled(ButtonComponent)`
    padding: 0px;
    border: none;
    border-radius: 0px;
    background-color: unset;
    transition: none;

    &:hover {
        background-color: unset;
        border-color: none;
        text-decoration: underline;
    }

    &:focus {
        border: none;
        outline: none;
        box-shadow: none;
        text-decoration: underline;
    }
`;

export const LinkButton = React.forwardRef<HTMLButtonElement, ButtonProps>(
    ({ variant = 'default', size = 'medium', ...rest }, ref) => {
        const { bento } = React.useContext(ThemeContext);
        const buttonTheme = typeof variant === 'string' ? getButtonTheme(bento, variant) : variant;
        return (
            <ThemeProvider theme={buttonTheme}>
                <LinkButtonComponent ref={ref} size={size} {...rest} />
            </ThemeProvider>
        );
    },
);
